import { Pipe, PipeTransform } from '@angular/core';
import { OrganizationService } from '../organization/organization.service';
import { BaseOrganizationProfile } from '../organization/organization';
import { AppContextService } from './app-context.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'appContextRoute',
  standalone: true,
})
export class AppContextRoutePipe implements PipeTransform {
  constructor(private organizationService: OrganizationService<BaseOrganizationProfile>, private appContextService: AppContextService) {}
  transform(path: string): Observable<string> {
    if (this.appContextService.isAppId('club_offering')) {
      return this.organizationService.organization$.pipe(
        map(organization => {
          return `${organization?.id}/${path}`;
        }),
      );
    }

    return of(path);
  }
}
